import { EmailTemplate } from '@greystar/ui';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { escape as escapeHTML } from 'html-escaper';

dayjs.extend(advancedFormat);

export const getEmailTemplateConfig = ({
  trackingEmail,
  emailTemplates,
}: {
  trackingEmail?: string | null;
  emailTemplates: EmailTemplate[];
}): EmailTemplate | null => {
  const templates = [...emailTemplates.values()];
  let emailTemplate = templates.find((template) => {
    const appliesToAddress =
      ((template?.fields?.appliesToAddresses as Field)?.value as string) ?? '';
    const domains = appliesToAddress.split(',').map((str) => str.trim());
    return domains.some((domain) => trackingEmail?.endsWith(`@${domain}`));
  });

  //Find fallback template with no appliesToAddresses
  emailTemplate ??= templates.find((template) => {
    const appliesToAddress =
      ((template?.fields?.appliesToAddresses as Field)?.value as string) ?? '';
    return !appliesToAddress;
  });

  return emailTemplate ?? null;
};

export const populateEmailContent = ({
  template,
  data,
  escape,
}: {
  template: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  escape: boolean;
}) => {
  return template.replace(/\${([^}]+)}/g, (_ignore, key) => {
    let value = process({ key, data });
    if (escape) {
      value = value ? escapeHTML(value) : null;
    }
    value = value ? value.replace('\n', '') : null;
    return value ?? '';
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const process = ({ key, data }: { key: string; data: any }) => {
  if (key.includes(':')) {
    return functions({ key, data });
  } else {
    return getNestedProperty({ key, data });
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const functions = ({ key, data }: { key: string; data: any }) => {
  const [func, param] = key.split(':');
  const props = new URLSearchParams(param);
  const prop = props.get('prop') ?? '';
  const format = props.get('format') ?? '';
  const value = getNestedProperty({ key: prop, data });

  if (func === 'dateformat') {
    return dayjs(value).format(format);
  } else if (func === 'map') {
    return props.get(value) ?? value ?? '';
  } else if (func === 'fallback') {
    return value || props.get('fallback');
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getNestedProperty = ({ key, data }: { key: string; data: any }) => {
  return key.split('.').reduce((parent, child) => parent?.[child] ?? '', data);
};
